import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';
import { AuditTrailDto } from './../../../core/models/view-model/audit-trail-dto';
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { UserProfile } from 'src/app/core/models/user';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { FilterViewModel } from 'src/app/core/models/regulation';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { MasterHelper } from 'src/app/core/utilities';
import { AuditTrailMasterFilter } from 'src/app/core/models/user-management/audit-trail-master-filter';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { GlobalService } from 'src/app/core/services/global/global.service';

@Component({
  selector: 'app-audit-trail-filters',
  templateUrl: './audit-trail-filters.component.html',
  styleUrls: ['./audit-trail-filters.component.scss'],
})
export class AuditTrailFiltersComponent implements OnInit {
  @Output() OnFilter = new EventEmitter<any>();
  @ViewChild('autoKeyword') autoKeyword!: MatAutocomplete;

  auditTrailFilters: AuditTrailDto;
  filterPersistenceKey = 'auditTrailFilters';
  user: UserProfile;
  searchedUsers: FilterViewModel[] = [];
  searchedScreens: FilterViewModel[] = [];
  searchedFunctions: FilterViewModel[] = [];
  searchedActions: FilterViewModel[] = [];
  masterFilters: AuditTrailMasterFilter;

  separatorKeysCodes: number[] = [ENTER, COMMA];
  isLoadingFilters = false;
  searchUserCntrl: FormControl = new FormControl();
  searchScreenCntrl: FormControl = new FormControl();
  searchFunctionCntrl: FormControl = new FormControl();
  searchActionCntrl: FormControl = new FormControl();
  keyCtrl = new FormControl();

  @ViewChild('userInput')
  userInput!: ElementRef<HTMLInputElement>;
  @ViewChild('userAutocomplete')
  userAutocomplete!: MatAutocomplete;

  @ViewChild('screenInput')
  screenInput!: ElementRef<HTMLInputElement>;
  @ViewChild('screenAutocomplete')
  screenAutocomplete!: MatAutocomplete;

  @ViewChild('functionInput')
  functionInput!: ElementRef<HTMLInputElement>;
  @ViewChild('functionAutocomplete')
  functionAutocomplete!: MatAutocomplete;

  @ViewChild('actionInput')
  actionInput!: ElementRef<HTMLInputElement>;
  @ViewChild('actionAutocomplete')
  actionAutocomplete!: MatAutocomplete;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;

  constructor(
    private userManagementService: UserManagementService,
    private sessionService: SessionService,
    private _globalService: GlobalService
  ) {
    this.auditTrailFilters = new AuditTrailDto();
    this.masterFilters = new AuditTrailMasterFilter();
    this.user = new UserProfile();

    this.auditTrailFilters.SortKey = 'CreatedDateTime';
    this.auditTrailFilters = MasterHelper.parseAuditTrailFilters(this.auditTrailFilters) as AuditTrailDto;
    const persistFilter = JSON.parse(this.fetchFromBrowser(
      this.filterPersistenceKey
    ) as string) as AuditTrailDto;
    if (persistFilter) {
      this.auditTrailFilters = persistFilter;
    }
  }

  async ngOnInit() {
    this.getMasterFilters();
    this.user = await this._globalService.getLoginUserData();
  }

  initFilters(): void {
    this.auditTrailFilters.fromDate = MasterHelper.getDateStr(30);
    this.auditTrailFilters.toDate = MasterHelper.getDateStr(0);
    this.auditTrailFilters.users = [];
    this.auditTrailFilters.screens = [];
    this.auditTrailFilters.functions = [];
    this.auditTrailFilters.actions = [];
    this.auditTrailFilters.searchQuery = [];
    this.searchedUsers = this.masterFilters.users;
    this.searchedScreens = this.masterFilters.screens;
    this.searchedFunctions = this.masterFilters.functions;
    this.searchedActions = this.masterFilters.actions;
    this.auditTrailFilters.SortKey = 'CreatedDateTime';
    this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(this.auditTrailFilters));
  }

  getMasterFilters(): void {
    this.isLoadingFilters = true;
    this.userManagementService.getAuditTrailFilters(this.auditTrailFilters).subscribe((result: AuditTrailMasterFilter) => {
      this.masterFilters = result;
      this.searchedUsers = this.masterFilters.users;
      this.searchedScreens = this.masterFilters.screens;
      this.searchedFunctions = this.masterFilters.functions;
      this.searchedActions = this.masterFilters.actions;
      this.isLoadingFilters = false;

      this.searchUserCntrl.valueChanges.subscribe((data: any) => {
        this.searchedUsers = data
          ? this.filterUser(data)
          : this.masterFilters.users;
      });

      this.searchScreenCntrl.valueChanges.subscribe((data: any) => {
        this.searchedScreens = data
          ? this.filterScreen(data)
          : this.masterFilters.screens;
      });

      this.searchFunctionCntrl.valueChanges.subscribe((data: any) => {
        this.searchedFunctions = data
          ? this.filterFunction(data)
          : this.masterFilters.functions;
      });

      this.searchActionCntrl.valueChanges.subscribe((data: any) => {
        this.searchedActions = data
          ? this.filterAction(data)
          : this.masterFilters.actions;
      });
    });
  }

  filterUser(search: string): any {
    return this.searchedUsers.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addUser(event: MatChipInputEvent): void {
    if (!this.userAutocomplete.isOpen) {
      const input = event.input;
      const value = event.value;

      if ((value || '').trim()) {
        (this.auditTrailFilters.users as string[]).push(value);
      }

      if (input) {
        input.value = '';
      }
      this.searchUserCntrl.setValue(null);
    }
  }

  selectedUserEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.auditTrailFilters.users) {
      this.auditTrailFilters.users.push(event.option.viewValue);
    } else {
      this.auditTrailFilters.users = [];
      this.auditTrailFilters.users.push(event.option.viewValue);
    }
    this.userInput.nativeElement.value = '';
    this.searchUserCntrl.setValue(null);
    this.searchUserCntrl.disable();
    this.searchUserCntrl.enable();
  }

  removeUser(status: string): void {
    const index = (this.auditTrailFilters.users as string[]).indexOf(status);

    if (index >= 0) {
      (this.auditTrailFilters.users as string[]).splice(index, 1);
    }
  }

  filterScreen(search: string): any {
    return this.searchedScreens.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addScreen(event: MatChipInputEvent): void {
    if (!this.screenAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.auditTrailFilters.screens as string[]).push(value);
      }

      // Reset the input value
      event.chipInput!.clear();
      this.searchScreenCntrl.setValue(null);
    }
  }

  removeScreen(status: string): void {
    const index = (this.auditTrailFilters.screens as string[]).indexOf(status);

    if (index >= 0) {
      (this.auditTrailFilters.screens as string[]).splice(index, 1);
    }
  }

  selectedScreenEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.auditTrailFilters.screens) {
      this.auditTrailFilters.screens.push(event.option.viewValue);
    } else {
      this.auditTrailFilters.screens = [];
      this.auditTrailFilters.screens.push(event.option.viewValue);
    }
    this.screenInput.nativeElement.value = '';
    this.searchScreenCntrl.setValue(null);
    this.searchScreenCntrl.disable();
    this.searchScreenCntrl.enable();
  }

  filterFunction(search: string): any {
    return this.searchedFunctions.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addFunction(event: MatChipInputEvent): void {
    if (!this.functionAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.auditTrailFilters.functions as string[]).push(value);
      }

      // Reset the input value
      event.chipInput!.clear();
      this.searchFunctionCntrl.setValue(null);
    }
  }

  removeFunction(status: string): void {
    const index = (this.auditTrailFilters.functions as string[]).indexOf(status);

    if (index >= 0) {
      (this.auditTrailFilters.functions as string[]).splice(index, 1);
    }
  }

  selectedFunction(event: MatAutocompleteSelectedEvent): void {
    if (this.auditTrailFilters.functions) {
      this.auditTrailFilters.functions.push(event.option.viewValue);
    } else {
      this.auditTrailFilters.functions = [];
      this.auditTrailFilters.functions.push(event.option.viewValue);
    }
    this.functionInput.nativeElement.value = '';
    this.searchFunctionCntrl.setValue(null);
    this.searchFunctionCntrl.disable();
    this.searchFunctionCntrl.enable();
  }

  filterAction(search: string): any {
    return this.searchedActions.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addAction(event: MatChipInputEvent): void {
    if (!this.actionAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.auditTrailFilters.actions as string[]).push(value);
      }

      // Reset the input value
      event.chipInput!.clear();
      this.searchActionCntrl.setValue(null);
    }
  }

  removeAction(status: string): void {
    const index = (this.auditTrailFilters.actions as string[]).indexOf(status);

    if (index >= 0) {
      (this.auditTrailFilters.actions as string[]).splice(index, 1);
    }
  }

  selectedAction(event: MatAutocompleteSelectedEvent): void {
    if (this.auditTrailFilters.actions) {
      this.auditTrailFilters.actions.push(event.option.viewValue);
    } else {
      this.auditTrailFilters.actions = [];
      this.auditTrailFilters.actions.push(event.option.viewValue);
    }
    this.actionInput.nativeElement.value = '';
    this.searchActionCntrl.setValue(null);
    this.searchActionCntrl.disable();
    this.searchActionCntrl.enable();
  }

  saveOnBrowser(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  fetchFromBrowser(key: string): any {
    return localStorage.getItem(key);
  }

  TriggerAction(): void {
    this.auditTrailFilters = MasterHelper.parseAuditTrailFilters(this.auditTrailFilters) as AuditTrailDto;
    this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(this.auditTrailFilters));
    this.OnFilter.emit(this.auditTrailFilters);
  }
}
